/* eslint-disable react/forbid-elements */
/* eslint-disable jsx-a11y/media-has-caption */
import './ProductPage.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';
import React from 'react';

import { Accordion } from '../Accordion';
import { useAppContext } from '../AppContext';
// import { Breadcrumb } from '../Breadcrumb';
import { Button, ButtonVariant } from '../Button';
import { Container } from '../Container';
import { PageBuilderSpacers } from '../contentTypes';
import { CustomRadio } from '../CustomRadio';
import { t } from '../i18n/i18n';
import { Icon, IconName, IconSize } from '../Icon';
import { AssetA, AssetAContentType } from '../pageBuilder/AssetA';
import { DynamicColumnsA, DynamicColumnsAContentType } from '../pageBuilder/DynamicColumnsA';
import { ProductsSlider } from '../slider/ProductsSlider';
import { Page } from './Page';

export interface ProductPagePros {}

export const ProductPage = (props: ProductPagePros) => {
  const product = b2x.useProduct({ populate: b2x.appConfig.api?.productPopulate });
  const { isFooterCopyrightVisible, isTopBarRowVisible } = useAppContext();
  const [variantsDivContainer, scrollToVariantsDivContainer] = b2x.useScrollTo(-180);
  const { session } = b2x.useAppContext();

  const currentBreakpoint = b2x.useBreakpoint();

  return (
    <Page
      background="primary"
      className="product-page"
      noPaddingBottom
      noPaddingTop
      thingsToLoadBeforePageReady={[product]}
    >
      {product !== undefined && (
        <b2x.ProductContext product={product}>
          {(productContext) => {
            return (
              <React.Fragment>
                <b2x.structuredData.Product product={product} selectedSku={productContext.selectedSku} />
                <section className="product-first-section py-lg-5 mb-3 mb-lg-0 bg-white">
                  <Container>
                    {b2x.untilBreakpoint('md', currentBreakpoint) && productContext.selectedProductVariant.name && (
                      <b2x.Col size={12}>
                        <b2x.Div paddingTop={3}>
                          {/* <Breadcrumb /> */}
                          <ProductBreadcrumbs productName={productContext.selectedProductVariant.name} />
                        </b2x.Div>
                      </b2x.Col>
                    )}
                    <b2x.Row>
                      <b2x.Col size={{ lg: 6, xs: 12 }}>
                        <div className="position-relative">
                          <ProductGallery
                            product={product}
                            selectedProductVariant={productContext.selectedProductVariant}
                            selectedSku={productContext.selectedSku}
                          />
                        </div>
                      </b2x.Col>
                      <b2x.Col size={{ lg: 6, xs: 12 }}>
                        <div className="ps-lg-5">
                          {!b2x.untilBreakpoint('md', currentBreakpoint) &&
                            productContext.selectedProductVariant.name && (
                              <b2x.Div className="border-bottom" marginBottom={2} paddingBottom={1}>
                                {/* <Breadcrumb /> */}
                                <ProductBreadcrumbs productName={productContext.selectedProductVariant.name} />
                              </b2x.Div>
                            )}
                          {productContext.selectedProductVariant.name && (
                            <b2x.H1 className="product-title display-1 fw-bold" marginBottom={1}>
                              {b2x.formatHtml(productContext.selectedProductVariant.name)}
                            </b2x.H1>
                          )}
                          {productContext.selectedProductVariant.descriptionShort && (
                            <b2x.H3 className="fw-light text-uppercase" marginBottom={1}>
                              {b2x.formatHtml(productContext.selectedProductVariant.descriptionShort)}
                            </b2x.H3>
                          )}
                          {productContext.selectedSku?.name && (
                            <b2x.H6 className="fw-light text-uppercase mb-3">{productContext.selectedSku.name}</b2x.H6>
                          )}
                          {productContext.selectedSku?.measurement && !product.assembled && (
                            <p className="small mb-2 mb-md-4">
                              {b2x.formatHtml(
                                t('productPage.measurement', {
                                  measurementUnit:
                                    productContext.selectedSku.measurement.measurementUnit?.toLowerCase(),
                                  value: `<span class="fw-light">${productContext.selectedSku.measurement.value}</span>`,
                                })
                              )}
                            </p>
                          )}
                          <b2x.AddToCartFormHelper className="mb-3" product={product} scope="product">
                            {({ fieldsHelper, formik, priceHelper, selectedProductVariant, selectedSku }) => (
                              <React.Fragment>
                                <div className="product-variants-container" ref={variantsDivContainer}>
                                  {fieldsHelper.skusFieldSet.skus.formFields.length > 1 && (
                                    <div className="product-skus">
                                      <fieldset>
                                        <legend className="visually-hidden">{fieldsHelper.skusFieldSet.legend}</legend>
                                        <b2x.FormGroup
                                          {...fieldsHelper.skusFieldSet.skus.formGroup}
                                          className="my-2 product-variants-container-form-group"
                                          label={undefined}
                                          labelClassName="mb-1 fw-bold"
                                          noMarginBottom
                                        >
                                          <b2x.SwiperContext>
                                            {({ navigationNextElRef, navigationPrevElRef }) => {
                                              return (
                                                <b2x.Div className="slider-container">
                                                  <Button
                                                    aria-label={t('accessibility.button.swiper_prev')}
                                                    className="prev"
                                                    iconStart={{ name: 'light-arrow-left' }}
                                                    innerRef={navigationPrevElRef}
                                                    justifyContent="start"
                                                    variant="blank"
                                                  />
                                                  <b2x.Swiper
                                                    navigation={{ custom: true }}
                                                    slides={fieldsHelper.skusFieldSet.skus.formFields.map(
                                                      ({ radio, sku }) => {
                                                        const label =
                                                          sku.attributes
                                                            ?.find(
                                                              (attribute) => attribute.typeCode === 'BSK_NOME_VARIANTE'
                                                            )
                                                            ?.value?.toLocaleLowerCase() ??
                                                          sku.name?.toLocaleLowerCase() ??
                                                          '';

                                                        const imageUrl = sku.attributes?.find(
                                                          (attribute) => attribute.typeCode === 'BSK_ICONA_COLORE'
                                                        )?.value;

                                                        const type = imageUrl ? 'icon' : 'text';
                                                        return (
                                                          <CustomRadio
                                                            className="pb-1"
                                                            image={
                                                              imageUrl
                                                                ? { alt: label, title: label, url: imageUrl }
                                                                : undefined
                                                            }
                                                            key={radio.id}
                                                            label={label}
                                                            radio={radio}
                                                            type={type}
                                                          />
                                                        );
                                                      }
                                                    )}
                                                    slidesPerView={'auto'}
                                                    spaceBetween={8}
                                                  />
                                                  <Button
                                                    aria-label={t('accessibility.button.swiper_next')}
                                                    className="next"
                                                    iconStart={{ name: 'light-arrow-right' }}
                                                    innerRef={navigationNextElRef}
                                                    justifyContent="end"
                                                    variant="blank"
                                                  />
                                                </b2x.Div>
                                              );
                                            }}
                                          </b2x.SwiperContext>
                                        </b2x.FormGroup>
                                      </fieldset>
                                    </div>
                                  )}
                                </div>
                                <ProductPrice priceHelper={priceHelper} />
                                {product.description && (
                                  <b2x.Div className="fw-light" marginBottom={{ lg: 5, xs: 3 }}>
                                    {b2x.formatHtml(product.description)}
                                  </b2x.Div>
                                )}
                                <div className="hstack gap-3 mb-3 mb-md-4">
                                  {selectedSku?.state === 'AVAILABLE' && (
                                    <b2x.FormGroup
                                      className="quantity-container"
                                      {...fieldsHelper.quantity.formGroup}
                                      label={undefined}
                                      noMarginBottom
                                    >
                                      <div className="d-flex overflow-hidden h-100">
                                        <b2x.Button
                                          className="px-2"
                                          variant="outline-link"
                                          {...fieldsHelper.buttons.quantity.decrease}
                                          aria-label={t('accessibility.form.addToCartForm.buttons.decreasingQnt')}
                                          iconStart={{ name: 'minus', size: 16 }}
                                          label={undefined}
                                        />
                                        <b2x.NumberInput
                                          className="border-0 text-center fw-bold bg-transparent px-2 py-2"
                                          style={{ width: 45 }}
                                          {...fieldsHelper.quantity.numberInput}
                                          aria-label={t('accessibility.quantity')}
                                          placeholder={undefined}
                                          readOnly
                                        />
                                        <b2x.Button
                                          className="px-2"
                                          variant="outline-link"
                                          {...fieldsHelper.buttons.quantity.increase}
                                          aria-label={t('accessibility.form.addToCartForm.buttons.increasingQnt')}
                                          iconStart={{ name: 'plus', size: 16 }}
                                          label={undefined}
                                        />
                                      </div>
                                    </b2x.FormGroup>
                                  )}
                                  <div className="add-to-cart-button-container">
                                    {selectedSku?.state === 'AVAILABLE' ? (
                                      <b2x.AddToCartFormButton<ButtonVariant, IconName, IconSize>
                                        fieldsHelper={fieldsHelper}
                                        product={product}
                                        selectedSku={selectedSku}
                                        submitButton={{
                                          iconStart: { name: 'plus', size: 12 },
                                          label: t('form.addToCartForm.buttons.submit.label'),
                                          variant: 'outline-primary',
                                        }}
                                      />
                                    ) : (
                                      <Button disabled variant="outline-primary">
                                        {t('misc.productNotAvailable')}
                                      </Button>
                                    )}
                                  </div>
                                </div>
                                <b2x.Portal>
                                  <b2x.ProductStickyFooter
                                    fieldsHelper={fieldsHelper}
                                    formik={formik}
                                    isVisible={!isTopBarRowVisible && !isFooterCopyrightVisible}
                                    priceHelper={priceHelper}
                                    product={product}
                                    scrollToElement={scrollToVariantsDivContainer}
                                    selectedProductImage={selectedProductVariant.image}
                                    selectedSku={selectedSku}
                                    submitDesktopButton={{
                                      iconStart: { name: 'plus', size: 12 },
                                      label:
                                        selectedSku?.state === 'AVAILABLE'
                                          ? t('form.addToCartForm.buttons.submit.label')
                                          : t('misc.productNotAvailable'),
                                      variant: 'outline-primary',
                                    }}
                                    submitMobileButton={{
                                      iconStart: { name: 'cart', size: 18 },
                                      label: undefined,
                                      onClick: formik.submitForm,
                                    }}
                                  />
                                </b2x.Portal>
                                <div className="my-3">
                                  <b2x.InstallmentPaymentBanner amount={priceHelper.price} />
                                </div>
                              </React.Fragment>
                            )}
                          </b2x.AddToCartFormHelper>

                          <AttributesSection
                            attributesToShow={['BSK_INGREDIENTI', 'BSK_MODO_USO']}
                            product={productContext.selectedProductVariant}
                            sku={productContext.selectedSku}
                          />

                          {session?.cart?.shippingProfile?.freeThreshold && (
                            <p className="small">
                              {b2x.formatHtml(
                                t('product.freeShippingFrom', {
                                  freeShippingFromAmount: b2x.formatCurrency(
                                    session.cart.shippingProfile.freeThreshold
                                  ),
                                })
                              )}
                            </p>
                          )}
                        </div>
                      </b2x.Col>
                    </b2x.Row>
                  </Container>
                </section>
                <ProductMediaContent />
                <b2x.RelatedProducts productId={productContext.selectedProductVariant.id}>
                  {({ fetching, relatedProducts }) =>
                    fetching ? (
                      <b2x.Loading />
                    ) : (
                      relatedProducts &&
                      relatedProducts.length > 0 && (
                        <section className="product-third-section">
                          <b2x.Container fluid="always">
                            <div className="bg-white px-3 px-lg-5 py-5 overflow-hidden">
                              <b2x.P
                                className={'text-uppercase letter-spacing-sm'}
                                fontWeight={700}
                                marginBottom={4}
                                textAlign={'center'}
                              >
                                {t('product.relatedProduct.title')}
                              </b2x.P>
                              <b2x.Listing
                                name="Product page - Related products"
                                products={relatedProducts}
                                sendEvent={false}
                              >
                                <ProductsSlider fullWidth products={relatedProducts} />
                              </b2x.Listing>
                            </div>
                          </b2x.Container>
                        </section>
                      )
                    )
                  }
                </b2x.RelatedProducts>
              </React.Fragment>
            );
          }}
        </b2x.ProductContext>
      )}
    </Page>
  );
};
export interface ProductPriceProps {
  priceHelper: b2x.UsePriceResult;
}

export const ProductPrice = ({ priceHelper }: ProductPriceProps) => {
  return (
    <b2x.Div
      className="product-price-container"
      display="flex"
      flexDirection="column"
      gap={2}
      marginY={{
        lg: 4,
        xs: 3,
      }}
    >
      <div>
        <b2x.PriceBlock
          alignItems="center"
          classNames={{
            discountPercentage: 'bg-primary text-white px-2',
            price: 'fw-bold',
          }}
          gap={2}
          priceHelper={priceHelper}
        />
      </div>
      {b2x.appConfig.enableBestPrice && priceHelper.bestPriceValue && (
        <div className="extra-small">
          <b2x.BestPrice priceHelper={priceHelper} />
        </div>
      )}
    </b2x.Div>
  );
};

export interface AttributesSectionProps {
  attributesToShow: Array<string>;
  product: b2x.ProductApiDto;
  sku?: b2x.SkuApiDto;
}

export const AttributesSection = ({ attributesToShow, product }: AttributesSectionProps) => {
  const attributes = attributesToShow.map((attributeToShow) =>
    product.attributes?.find((attribute) => attribute.typeCode === attributeToShow)
  );

  return (
    <section className="py-3 mb-3 position-relative">
      <Accordion id="product-accordion">
        {attributes.length > 0 &&
          attributes.map((attribute) => (
            <React.Fragment key={attribute?.typeCode}>
              {attribute && (
                <AttributeAccordionItem attribute={attribute} key={attribute.typeCode} productCode={product.code} />
              )}
            </React.Fragment>
          ))}
      </Accordion>
    </section>
  );
};

export const AttributeAccordionItem = ({
  attribute,
  icon,
  productCode,
}: {
  attribute: b2x.AttributeApiDto;
  icon?: IconName;
  productCode?: string;
}) => {
  return (
    <b2x.AccordionItem
      accordionBodyClassName={`fw-light ${icon ? 'bg-mint' : ''}`}
      accordionButtonClassName={icon ? 'bg-mint' : ''}
      id={attribute.typeCode}
      title={
        <b2x.Div className="hstack w-100" justifyContent="spaceBetween" paddingEnd={3}>
          <b2x.Span alignItems="center" display="flex" gap={2}>
            {icon && <Icon name={icon} size={30} />}
            {attribute.title}
          </b2x.Span>
        </b2x.Div>
      }
    >
      {b2x.formatHtml(attribute.value)}
      {attribute.typeCode === 'BSK_MODO_USO' && (
        <div className="text-primary small text-gray-600 pt-3">
          {t('product.code')}: {productCode?.replace('B2X_', '')}
        </div>
      )}
    </b2x.AccordionItem>
  );
};

export interface ProductGalleryProps {
  product: b2x.ProductApiDto;
  selectedProductVariant: b2x.ProductApiDto;
  selectedSku?: b2x.SkuApiDto;
}

export const ProductGallery = ({ product, selectedProductVariant, selectedSku }: ProductGalleryProps) => {
  const [thumbsSwiper, setThumbsSwiper] = React.useState<b2x.SwiperClass>();

  const { stickersProductWithoutImage } = b2x.useStickersProduct({ product: selectedProductVariant });

  const slides = b2x.useGallery(selectedProductVariant, selectedSku).slides;

  return (
    <b2x.Div className="product-gallery" display="flex" flexDirection="column" gap={3} marginBottom={3}>
      <div className="gallery-slides position-relative">
        {stickersProductWithoutImage && stickersProductWithoutImage.length > 0 && (
          <b2x.Div className="product-stickers pt-3 px-3 d-flex gap-3">
            {stickersProductWithoutImage.map((sticker) => (
              <b2x.Div
                className={classnames(
                  'sticker',
                  sticker.code,
                  'px-2 text-uppercase fw-bold',
                  { 'bg-transparent': !sticker.backgroundColor },
                  { 'border border-black': !sticker.borderColor },
                  { 'text-black': !sticker.textColor }
                )}
                key={sticker.code}
                style={{
                  backgroundColor: sticker.backgroundColor,
                  border: sticker.borderColor ? `1px solid ${sticker.borderColor}` : undefined,
                  color: sticker.textColor,
                }}
              >
                {sticker.label}
              </b2x.Div>
            ))}
          </b2x.Div>
        )}
        <b2x.Lightbox>
          <b2x.SwiperContext>
            {(swiper) => (
              <b2x.Swiper
                pagination
                slides={slides.map(({ src, type, uId }, index) => (
                  <div className="slide-container" key={uId}>
                    {type === 'image' ? (
                      <b2x.ImageSwitcher
                        alt={product.name}
                        aspectRatio={b2x.appConfig.productImageAspectRatio}
                        fluid
                        src={src}
                      />
                    ) : (
                      swiper.swiper?.activeIndex === index && (
                        <b2x.Video
                          options={{
                            autoplay: swiper.swiper?.activeIndex === index,
                            controls: true,
                            loop: true,
                            muted: true,
                            pip: false,
                            playsinline: true,
                          }}
                          variants={{ xs: { height: 1080, source: { external: { file: src } }, width: 1920 } }}
                        />
                      )
                    )}
                  </div>
                ))}
                thumbs={{
                  slideThumbActiveClass: 'border',
                  swiper: thumbsSwiper,
                }}
              />
            )}
          </b2x.SwiperContext>
        </b2x.Lightbox>
      </div>
      <div className="gallery-thumbnails d-none d-lg-block">
        <b2x.SwiperContext>
          {({ navigationNextElRef, navigationPrevElRef }) => (
            <>
              <b2x.Swiper
                direction="horizontal"
                navigation={{ custom: true }}
                onSwiper={setThumbsSwiper}
                slides={slides.map(({ src, thumbnail, type, uId }) => (
                  <div className="slide-container" key={uId}>
                    {type === 'image' ? (
                      <b2x.ImageSwitcher
                        alt={`${product.name} thumbnail`}
                        aspectRatio={b2x.appConfig.productImageAspectRatio}
                        fluid
                        src={thumbnail}
                      />
                    ) : (
                      <div className="position-relative">
                        <b2x.Video
                          options={{
                            autoplay: false,
                            controls: false,
                            loop: false,
                            muted: false,
                            pip: false,
                            playsinline: false,
                          }}
                          variants={{ xs: { height: 1080, source: { external: { file: src } }, width: 1920 } }}
                        />
                        <b2x.Div
                          alignItems={'center'}
                          className="position-absolute w-100 h-100 top-0 start-0 bg-dark bg-opacity-25 text-light"
                          display={'flex'}
                          justifyContent={'center'}
                        >
                          <Icon name="privacy" size={20} />
                        </b2x.Div>
                      </div>
                    )}
                  </div>
                ))}
                slidesPerView={'auto'}
                spaceBetween={16}
                watchSlidesProgress
              />
              <div className="navigation">
                <Button innerRef={navigationPrevElRef} variant="blank">
                  <Icon className="slider-arrow-right text-dark" name={'light-arrow-left'} size={24} />
                </Button>
                <Button innerRef={navigationNextElRef} variant="blank">
                  <Icon className="slider-arrow-right text-dark" name={'light-arrow-right'} size={24} />
                </Button>
              </div>
            </>
          )}
        </b2x.SwiperContext>
      </div>
    </b2x.Div>
  );
};

export interface ProductMediaContentType {
  sections?: b2x.contentTypes.ContentSectionList<{
    component?: b2x.contentTypes.ContentSectionList<{
      assetA?: AssetAContentType;
      dynamicColumnsA?: DynamicColumnsAContentType;
    }>;
    options?: {
      background?: string;
      // enabled?: boolean;
      // margin?: PageBuilderSpacers;
      padding?: PageBuilderSpacers;
      // class?: string;
    };
  }>;
}

export const ProductMediaContent = () => {
  const { selectedProductVariant } = b2x.useProductContext();

  const attributeMediaProduct = selectedProductVariant.attributes?.find(
    (attribute) => attribute.typeCode === 'BSK_PRODUCT_MEDIA_CONTENT'
  );
  const content = b2x.useContent<ProductMediaContentType>(attributeMediaProduct?.value);

  const body = content?.body;
  if (!body) {
    return null;
  }

  return (
    <div className="product-media-content">
      {body.sections?.map((section) => {
        const componentFound = section.component?.at(0);
        if (!componentFound) {
          return null;
        }

        let component = null;
        if (componentFound.assetA) {
          component = <AssetA {...componentFound.assetA} key={section.contentSectionId} />;
        } else if (componentFound.dynamicColumnsA) {
          component = <DynamicColumnsA {...componentFound.dynamicColumnsA} key={section.contentSectionId} />;
        }

        const background = section.options?.background;

        // Section padding
        const _paddingTop = section.options?.padding?.top;
        const _paddingBottom = section.options?.padding?.bottom;
        // Se è settato default, ed è presente un background viene impostato un padding top di default per dare "aria" al componente
        const paddingTop = {
          lg: _paddingTop?.lg === 'default' ? (background ? 5 : undefined) : _paddingTop?.lg,
          md: _paddingTop?.md === 'default' ? (background ? 3 : undefined) : _paddingTop?.md,
          sm: _paddingTop?.sm === 'default' ? (background ? 3 : undefined) : _paddingTop?.sm,
          xl: _paddingTop?.xl === 'default' ? (background ? 5 : undefined) : _paddingTop?.xl,
          xs: _paddingTop?.xs === 'default' ? (background ? 3 : undefined) : _paddingTop?.xs,
          xxl: _paddingTop?.xxl === 'default' ? (background ? 5 : undefined) : _paddingTop?.xxl,
        } as b2x.ResponsivePaddingSize;
        // Se è settato default, ed è presente un background viene impostato un padding bottom di default per dare "aria" al componente
        const paddingBottom = {
          lg: _paddingBottom?.lg === 'default' ? (background ? 5 : undefined) : _paddingBottom?.lg,
          md: _paddingBottom?.md === 'default' ? (background ? 3 : undefined) : _paddingBottom?.md,
          sm: _paddingBottom?.sm === 'default' ? (background ? 3 : undefined) : _paddingBottom?.sm,
          xl: _paddingBottom?.xl === 'default' ? (background ? 5 : undefined) : _paddingBottom?.xl,
          xs: _paddingBottom?.xs === 'default' ? (background ? 3 : undefined) : _paddingBottom?.xs,
          xxl: _paddingBottom?.xxl === 'default' ? (background ? 5 : undefined) : _paddingBottom?.xxl,
        } as b2x.ResponsivePaddingSize;

        return (
          <React.Fragment key={section.contentSectionId}>
            <React.Fragment>
              <b2x.Section
                background={background}
                paddingBottom={paddingBottom}
                paddingTop={paddingTop}
                style={{ overflow: 'hidden', position: 'relative' }}
              >
                <b2x.Div style={{ position: 'relative', zIndex: 20 }}>{component}</b2x.Div>
              </b2x.Section>
            </React.Fragment>
          </React.Fragment>
        );
      })}
    </div>
  );
};

interface ProductBreadcrumbsProp {
  productName: string;
}

const ProductBreadcrumbs = ({ productName }: ProductBreadcrumbsProp) => {
  const productsPage = b2x.usePageByCode('PRODUCTS_PAGE');
  const { getPagePath } = b2x.useAppStaticContext();

  return (
    <div className="Breadcrumb">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb justify-content-undefined lh-1" itemType="https://schema.org/BreadcrumbList">
          <li className="breadcrumb-item" itemProp="itemListElement" itemType="https://schema.org/ListItem">
            <b2x.router.NavLink
              className={'text-decoration-none'}
              itemID={getPagePath('SITEMAP')}
              itemProp="item"
              to={getPagePath('SITEMAP')}
            >
              <span className="" itemProp="name">
                Home
              </span>
            </b2x.router.NavLink>
            <meta content="1" itemProp="position" />
          </li>
          <li className="breadcrumb-item" itemProp="itemListElement" itemType="https://schema.org/ListItem">
            <b2x.router.NavLink
              className={'text-decoration-none'}
              itemID={getPagePath('PRODUCTS_PAGE')}
              itemProp="item"
              to={getPagePath('PRODUCTS_PAGE')}
            >
              <span className="" itemProp="name">
                {productsPage?.name}
              </span>
            </b2x.router.NavLink>
            <meta content="2" itemProp="position" />
          </li>
          <li
            aria-current="page"
            className="breadcrumb-item active"
            itemProp="itemListElement"
            itemType="https://schema.org/ListItem"
          >
            <span className="text-decoration-none" itemProp="name">
              {productName}
            </span>
            <meta content="3" itemProp="position" />
          </li>
        </ol>
      </nav>
    </div>
  );
};
